import { Grid } from '@chakra-ui/react';
import React from 'react';
import { ControllerRenderProps } from 'react-hook-form';
import { ContributionClassRolesDDL } from 'types/contribution';
import { ContributionClassNameRadioButton } from '../ContributionClassNameRadioButton';

interface RoleRadioFieldProps
  extends Pick<ControllerRenderProps, 'value' | 'onChange'> {
  disabled?: boolean;
  classes: ContributionClassRolesDDL;
}

export const RoleRadioField: React.FC<RoleRadioFieldProps> = ({
  onChange,
  value,
  disabled,
  classes,
}) => (
  <Grid gap={4} gridTemplateColumns="repeat(3, 1fr)">
    {Object.values(classes)
      .filter(({ key }) => key !== 'Other')
      .map((type) => (
        <ContributionClassNameRadioButton
          key={type.key}
          onChange={() => onChange(type.key)}
          checked={value === type.key}
          title={type.name}
          description={type.description}
          value={type.key}
          disabled={disabled}
        />
      ))}
  </Grid>
);
